import {
  StyleSheet,
  Text,
  TouchableWithoutFeedback,
  View,
} from "react-native";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import ButtonIcon from "../../../components/ButonIcon";
import * as Colors from "../../../styles/colors";
import * as Fonts from "../../../styles/typography";

export default function OptionUser({ title, subtitle, icon, iconColor, action }) {
  return (
    <TouchableWithoutFeedback onPress={action}>
      <View style={styles.option}>
        <View style={styles.optionInfo}>
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <View>
              <Text style={styles.optionTitle}>{title}</Text>
              <Text style={styles.optionSubtitle}>{subtitle}</Text>
            </View>
            {action ? (
              <ButtonIcon iconName={icon}
                colorButton={iconColor}
                onPress={action}
                size={24}
              />
            ) : null}
          </View>
        </View>
      </View>
    </TouchableWithoutFeedback>
  );
}

const styles = StyleSheet.create({
  option: {
    backgroundColor: Colors.SNOW,
    // borderRadius: 8,
    flexDirection: "row",
    padding: 16,
    justifyContent: "space-between",
    alignItems: "center",
    marginVertical: 4,
    borderColor: Colors.SECONDARY,
    borderLeftWidth: 2,
    shadowColor: Colors.GRAY_DARK,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    borderRadius: 8,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
  optionTitle: {
    fontSize: Fonts.FONT_SIZE_20,
    color: Colors.BLACK,
    fontWeight: "500",
    letterSpacing: 0.1,
    // marginLeft: 4,
  },
  optionSubtitle: {
    fontSize: Fonts.FONT_SIZE_16,
    lineHeight: Fonts.FONT_SIZE_18,
    color: Colors.GRAY_DARK,
    fontWeight: "500",
    marginTop: 4,
    marginLeft: 4,
  },
  optionInfo: {
    justifyContent: "flex-start",
    width: "100%",
  },
  optionAction: {
    backgroundColor: Colors.PRIMARY,
    paddingHorizontal: 4,
    paddingVertical: 4,
    marginTop: 8,
    alignItems: "center",
    borderRadius: 8,
    textAlign: "center",
  },
});
